import { useEffect } from 'react';

import isBrowser from '../../helpers/isBrowser';

const useDisableBodyScroll = (selector: string): void => {
    useEffect(() => {
        if (isBrowser() === false) {
            return () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
        }

        const selectedElement = document.querySelector(selector) as HTMLElement;

        if (!selectedElement || !selectedElement.parentElement) {
            return () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
        }

        selectedElement.style.overflow = 'hidden';

        return () => {
            selectedElement.style.removeProperty('overflow');
        };
    }, []);
};

export default useDisableBodyScroll;
